import { EDealType } from 'shared/types/offers';
import { sendAnalytics } from 'shared/utils/analytics';

const DEAL_TYPE_ANALYTICS_MAP: Partial<Record<EDealType, string>> = {
  [EDealType.Sale]: 'sale',
  [EDealType.RentLongterm]: 'longterm_rent',
  [EDealType.RentDaily]: 'forday_rent',
};

interface ITrackDealTypeFilterChangeParams {
  dealType: EDealType;
  count: number;
}

export const trackDealTypeFilterChange = ({ dealType, count }: ITrackDealTypeFilterChangeParams) =>
  sendAnalytics({ action: `select_${DEAL_TYPE_ANALYTICS_MAP[dealType]}`, label: `house_offers/${count}` });
